import moment from 'moment';

// STYLED COMPONENTS
// ========================================

// CONSTANTS
// ================================
const DEFAULT_LINE_ITEM = {
  description: '',
  amount: 0,
};
const DEFAULT_SALES_TAX = 0;

export const DEFAULT_CONTRACT_STATE = {
  keys: [],
  clientId: null,
  clientEmailMessage: null,
  clientEmailSubject: null,
  clientEmail: null,
  memo: null,
  createInvoices: 'dont-create',
  status: 'draft',
  salesTax: DEFAULT_SALES_TAX,
  lineItems: [],
  // DISCOUNT
  discountType: 'dollar-amount',
  currency: 'USD',
  sessionDate: null,
  discountValue: 0,
  discountAmount: 0,
  depositValue: 0,
  depositType: 'dollar-amount',
  depositAmount: 0,
  subtotalAfterDiscount: 0,
  // deposit
  depositValue: 0,
  depositAmount: 0,
  depositDueDate: null,
  depositType: 'dollar-amount', // 'dollar-amount' or 'percentage',
  //
  finalPaymentAmount: DEFAULT_LINE_ITEM.amount,
  totalWithTax: DEFAULT_LINE_ITEM.amount * (DEFAULT_SALES_TAX / 100),
  taxAmount: 0,
  total: DEFAULT_LINE_ITEM.amount,
  subtotalAfterTax: 0,
  subtotal: 0,
  finalPaymentDueDate: null,
  // SCHEDULED INVOICE
  scheduleInvoice: false,
  scheduledInvoiceDate: moment(),
  termsHTML: null,
};



// WEBPACK FOOTER //
// ./src/routes/contract-draft/constants.js